import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GetAllBookings from './pages/bookings/GetAllBookings';
import ViewBookingDetails from './pages/bookings/ViewBookingDetails';
import Profile from './pages/Profile';

import ProtectedRoute from './common/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="food-categories" element={<div style={{ padding: 20 }}>Food Categories (Placeholder)</div>} />
          <Route path="bookings" element={<GetAllBookings />} />
          <Route path="bookings/details/:id" element={<ViewBookingDetails />} />
          <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Route>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
